<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <tamanio-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TamanioCrud from "./TamanioCrud";
    export default {
        name: "Tamanio",
        components: {TamanioCrud}
    }
</script>

<style scoped>

</style>

